import {Component, Inject, LOCALE_ID} from '@angular/core';
import {Router} from "@angular/router";
import {GlobalService} from "../../../services/global.service";
import {ConfigService} from "../../../services/config.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-nowruz-sweets',
  standalone: true,
    imports: [
        NgIf
    ],
  templateUrl: './nowruz-sweets.component.html',
  styleUrl: './nowruz-sweets.component.css'
})
export class NowruzSweetsComponent {

  constructor(public route: Router,
              @Inject(LOCALE_ID) public locale: string,
              public global: GlobalService,
              public conf: ConfigService) {

  }
}
